<template>
  <div>
    <div class="people-slider__label">
      <strong>{{ label }}</strong>
    </div>


    <v-range-slider
      dark
      v-model="range"
      max="500"
      min="0"
      step="10"
      @change="onChange"
    />
    <v-row class="people-slider__hint">
      <v-col cols="6" align="left">
        {{ displayHint(range[0]) }}
      </v-col>

      <v-col cols="6" align="right">
        {{ displayHint(range[1]) }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: 'PeopleSlider',

    props: {
      label: {
        required: true,
        type: String,
      },

      name: {
        required: true,
        type: String,
      },
    },

    data() {
      return {
        range: [0, 500],
      }
    },

    methods: {
      displayHint(value) {
        if (value === 0) return '1 <'
        if (value === 500) return '> 500'

        return value
      },

      onChange() {
        this.$emit('change', {
          name: this.name,
          values: this.range,
        })
      },
    },

    mounted() {
      this.onChange()
    },
  }
</script>

<style lang="sass" scoped>
  .v-input
    margin-top: 10px

  .people-slider__hint
    margin-top: -30px
    font-size: 18px
</style>
